import { adalGetToken, adalFetch, AuthenticationContext } from 'react-adal';

// App Registration ID
const appId = '51f4e8fc-060c-445f-823b-d33673dd1a10';
export const adalConfig = {
  cacheLocation: 'localStorage',
  clientId: appId,
  redirectUri: 'https://' + window.location.host,
  endpoints: {
    api: appId,
  },
  postLogoutRedirectUri: window.location.origin,
};

class AzureAd {
  constructor() {
    this._authContext = new AuthenticationContext(adalConfig);
  }

  get authContext() {
    return this._authContext;
  }

  getToken = () => {
    // use either the appId or api endpoint
    return adalGetToken(this._authContext, appId);
  };

  getChachedToken = () => {
    return this._authContext.getChachedToken(appId);
  };

  getUser = () => {
    return this._authContext.getCachedUser();
  };

  logOut = () => {
    this._authContext.logOut();
  };

  adalApiFetch = (fetch, url, options) => {
    return adalFetch(this._authContext, appId, fetch, url, options);
  };
}

const azureAd = new AzureAd();
export default azureAd;
